<template>
	<div id="app">
		<GlobalHeader v-if="this.$route.name !== 'Farewell' && this.$route.name !== 'Friend'"></GlobalHeader>
		<section role="main" id="main-content">
			<router-view/>
		</section>
	</div>
</template>

<script>
import GlobalHeader from '@/components/GlobalHeader'
export default {
	name: 'Portfolio',
	components: {
		GlobalHeader
	}
}
</script>

<style lang="scss">
@import 'src/assets/css/global';

#app {
	min-height: 100vh;
	padding-bottom: 4rem;
}
</style>
